import { render, staticRenderFns } from "./ViberDetailFilter.vue?vue&type=template&id=10282f52&"
import script from "./ViberDetailFilter.vue?vue&type=script&lang=ts&"
export * from "./ViberDetailFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports